//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import switchTheme from '@/styles/themes/themes'
import { mapGetters, mapActions } from 'vuex'
import { eventEmitter } from '@/main.js'
export default {
	data: () => ({
		date: new Date(),
		interval: null,
		dropdown: null,
		isOpen: false,
		loading: true,
		categories: [
			{ title: 'Dashboard', path: '/', i: 'dashboard' },
			{ title: 'Markets', path: '/markets', i: 'poll' },
			{ title: 'Wallets', path: '/wallets', i: 'account_balance_wallet' },
		],
	}),
	computed: {
		getThemeColor() {
			return this.theme
		},
		...mapGetters(['theme']),
	},
	watch: {
		isOpen(val) {
			document.documentElement.style.overflow = val ? 'hidden' : 'auto'
			// if (window.screen.width > 600) {
			// 	const padding = val
			// 		? 'padding: 1.5rem 0.5rem 0.5rem 14rem'
			// 		: 'tpadding: 1.5rem 0.5rem 0.5rem 5.5rem'
			// 	this.$emit('drawer-resize', padding)
			// }
		},
	},

	methods: {
		...mapActions(['setTheme']),
		switchTheme() {
			const theme = this.getThemeColor === 'light' ? 'dark' : 'light'
			this.setTheme({ theme })
		},
		redirect(path) {
			if (this.$route.path === path) return
			this.$router.push(path)
			window.scroll({
				top: 0,
				left: 0,
			})
			this.isOpen = false
		},
	},
}
